import React from "react";
import Hero from "../components/Hero";
import Rankings from "../components/Rankings";
import Tournaments from "../components/Tournaments";
import WorldBand from "../components/WorldBand";
import GetRankedCta from "../components/GetRankedCta";

// Section rhythm per design system §17: white hero, light-gray rankings, white
// tournaments, navy world band, white CTA, then the navy footer.
export default function Home() {
  return (
    <>
      <Hero />
      <Rankings />
      <Tournaments />
      <WorldBand />
      <GetRankedCta />
    </>
  );
}
